export default ({
  state: {
    loading: false,
    error: null,
    GPS: null,
    url: 'https://cwelite.aquariusit.com',
    versions: {
      app: null,
      db: null
    },
    appOutdated: false,
    applicationMode: localStorage.getItem('applicationMode') !== null && localStorage.getItem('applicationMode') !== undefined ? localStorage.applicationMode : 'tanda',
    signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0,
    taSettings: []
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setGPS (state, payload) {
      state.GPS = payload
    },
    setURL (state, payload) {
      state.url = payload
    },
    setApplicationMode (state, payload) {
      state.applicationMode = payload
    },
    appOutdated (state, payload) {
      state.appOutdated = payload
    },
    setSignoutInterval (state, payload) {
      state.signoutInterval = payload
    },
    setTASettings (state, payload) {
      state.taSettings = payload
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    setLoading ({commit}, payload) {
      commit('setLoading', payload)
    },
    getLocation ({ commit }) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          commit('setGPS', position)
        },
        function (error) {
          commit('setGPS', error)
        })
      } else {
        commit('setGPS', null)
      }
    },
    setURL ({ commit }, payload) {
      commit('setURL', payload)
    },
    setApplicationMode ({ commit }, payload) {
      commit('setApplicationMode', payload)
    },
    appOutdated ({commit}, payload) {
      commit('appOutdated', payload)
    },
    setSignoutInterval ({commit}, payload) {
      commit('setSignoutInterval', payload)
    },
    setTASettings ({commit}, payload) {
      commit('setTASettings', payload)
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    GPS (state) {
      return state.GPS
    },
    url (state) {
      return state.url
    },
    applicationMode (state) {
      return state.applicationMode
    },
    appOutdated (state) {
      return state.appOutdated
    },
    signoutInterval (state) {
      return state.signoutInterval
    },
    taSettings (state) {
      return state.taSettings
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/shared/index.js